/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Oktawrongaccount2Inputs */

const en_auth_oktawrongaccount2 = /** @type {(inputs: Auth_Oktawrongaccount2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It appears that you are currently logged in with an Okta account that isn't associated with any eligible user. Please log out of your current session at okta.com if you wish to proceed with a different account.`)
};

/**
* | output |
* | --- |
* | "It appears that you are currently logged in with an Okta account that isn't associated with any eligible user. Please log out of your current session at okta..." |
*
* @param {Auth_Oktawrongaccount2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const auth_oktawrongaccount2 = /** @type {((inputs?: Auth_Oktawrongaccount2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Oktawrongaccount2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_oktawrongaccount2(inputs)
});
export { auth_oktawrongaccount2 as "auth_oktaWrongAccount" }